import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import constants, { fontWeight, fontSize, spacing } from '../common/theme/constants';

// ------------------
// KitTextSpacing.Group
// ------------------

export interface KitTextSpacingGroupProps extends PropsWithChildren {
  className?: string;
}

const KitTextSpacingGroup: FC<KitTextSpacingGroupProps> = ({ className, children }) => {
  return <div className={className}>{children}</div>;
};

const StyledKitTextSpacingGroup = styled(KitTextSpacingGroup)``;

// ------------------
// KitTextSpacing
// ------------------

// If using dt and dd remember to use <KitTextSpacing as='dl'...>
const KitTextSpacing = styled.div`
  display: block;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;

  ${StyledKitTextSpacingGroup} {
    margin-bottom: ${spacing.absolute.l}px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  & dt {
    font-size: ${fontSize.text_14}rem;
    font-weight: ${fontWeight.normal};
    color: ${({ theme }) => theme.card.body.headerText};
    margin-bottom: ${spacing.absolute.xs}px;
    margin-top: 0;
    padding: 0;
  }

  & dd {
    color: ${({ theme }) => theme.card.body.text};
    font-size: ${fontSize.text_14}rem;
    margin-inline-start: 0;
    margin-bottom: ${spacing.absolute.l}px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

// ------------------
// KitTextSpacing.PrimaryText
// ------------------

const KitPrimaryText = styled.h4`
  color: ${({ theme }) => theme.card.body.headerText};
  font-size: ${fontSize.text_14}rem;
  margin-bottom: ${constants.spacing.absolute.xs}px;
  font-weight: ${fontWeight.normal};
`;

// ------------------
// KitTextSpacing.SecondaryText
// ------------------

const SecondaryText = styled.div`
  color: ${({ theme }) => theme.card.body.text};
  font-size: ${fontSize.text_14}rem;
`;

export interface KitSecondaryTextProps extends PropsWithChildren {
  className?: string;
  'data-qa-id'?: string;
}

const KitSecondaryText: FC<KitSecondaryTextProps> = (props) => {
  return (
    <SecondaryText className={props.className} data-qa-id={props['data-qa-id']}>
      {props.children}
    </SecondaryText>
  );
};

export default Object.assign(KitTextSpacing, {
  Group: StyledKitTextSpacingGroup,
  PrimaryText: KitPrimaryText,
  SecondaryText: KitSecondaryText,
});
